/**
 * LocalStorage Utilities
 * 
 * Token management için localStorage wrapper fonksiyonları.
 * DRY principle - Token key tek bir yerde tanımlanır.
 */

/**
 * Token storage key
 * @constant {string}
 */
const TOKEN_KEY = 'contractcode_token';

/**
 * Token'ı localStorage'a kaydet
 * @param {string} token - JWT token to store
 */
export const setToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

/**
 * Token'ı localStorage'dan al
 * @returns {string|null} JWT token or null if not found
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Token'ı localStorage'dan sil
 */
export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

/**
 * Token varlığını kontrol et
 * @returns {boolean} True if token exists, false otherwise
 */
export const hasToken = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

